export default __webpack_public_path__ + "static/media/Customers.733af90f.png";